import { ReactComponent as LidoIcon } from "../../../components/icons/lido.svg";

const ethereum = {
  name: "Lido",
  icon: <LidoIcon width="24" height="24" />,
  value: "ethereum",
  domain: "ethereum",
  chain: "ethereum",
  protocol: "lido",
  symbol: "ETH",
  decimals: 18,
  color: "#00A3FF",
  colorSecondary: "rgba(0, 163, 255, 0.1)",
  nodes: [],
};

export default ethereum;
